import { GlobalErrorComponent } from './components/global-error/global-error.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [GlobalErrorComponent],
  exports: [GlobalErrorComponent]
})
export class ErrorModule { }
